<p-splitter class="height100p" panelStyleClass="flex-item-fill flex-row-split height100p">
    <ng-template pTemplate>
        <sm-table class="width100p" [data]="table" columnWidthMode="contentFlex" [floatingFilter]=true [useColumnMenu]=false [useTableMenu]=false (onRowSelect)="rowSelect($event)"></sm-table>
    </ng-template>
    <ng-template pTemplate>
        <app-pdf-viewer class="width100p height100p" [src]="pdfSrc"></app-pdf-viewer>
    </ng-template>
</p-splitter>
